import $ from '@vaersaagod/tools/Dom';

export default el => {
    const info = $(el).find('[aria-live="polite"]');
    const radioButtons = $(el).find('input[type="radio"]');

    const onRadioChange = e => {
        const radioButton = $(e.target);
        info.text(radioButton.data('info'));
    };

    const init = () => {
        radioButtons.on('change', onRadioChange);
    };

    const destroy = () => {
        radioButtons.off('change', onRadioChange);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FoodWasteRadios.js